module.exports = __webpack_public_path__ + "static/media/football-carousel-640x360.748f7877.jpg";